<template>
  <v-dialog v-model="isVisible" persistent max-width="450" content-class="confirm-dialog-content">
    <v-card class="confirm-card">
      <v-btn icon class="confirm-close-btn action-icon" @click="onCancel">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-card-title class="confirm-title">{{ dialogTitle }}</v-card-title>

      <v-card-text v-if="dialogMessage" class="confirm-message">
        {{ dialogMessage }}
      </v-card-text>

      <v-card-actions class="confirm-actions">
        <ButtonPrimary v-if="noConfirmButton" @click="onCancel">
          {{ dialogCancelText }}
        </ButtonPrimary>
        <ButtonSecondary v-if="confirmButtonPresent" class="btn-cancel" @click="onCancel">
          {{ dialogCancelText }}
        </ButtonSecondary>
        <ButtonPrimary v-if="confirmButtonPresent" class="btn-confirm" @click="onConfirm">
          {{ dialogConfirmText }}
        </ButtonPrimary>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import ButtonPrimary from "@/components/customComponents/ButtonPrimary.vue";
import ButtonSecondary from "@/components/customComponents/ButtonSecondary.vue";

export default Vue.extend({
  name: "ConfirmDialog",
  components: { ButtonSecondary, ButtonPrimary },
  computed: {
    ...mapGetters("confirmDialog", [
      "isVisible",
      "dialogTitle",
      "dialogMessage",
      "dialogCancelText",
      "dialogConfirmText",
      "resolveFn",
    ]),

    noConfirmButton(): boolean {
      return this.dialogConfirmText.length == 0;
    },

    confirmButtonPresent(): boolean {
      return this.dialogConfirmText.length > 0;
    },
  },
  methods: {
    ...mapActions("confirmDialog", ["close"]),
    onCancel() {
      this.resolveFn?.(false);
      this.close();
    },
    onConfirm() {
      this.resolveFn?.(true);
      this.close();
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

::v-deep .v-card__title {
  padding: 24px 0 0 0 !important;
}

::v-deep .v-card__text {
  padding: 0 0 18px 0 !important;
  color: white;
}

::v-deep .btn-dark.btn-confirm {
  background: #f84949 !important;
  color: #fff !important;
  box-sizing: border-box;
  width: 124px;
}

.confirm-card {
  position: relative;
  background-color: #262945 !important;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 64px 96px 12px #3a4f970a, 0 12px 10px 0 #3a4f970a, 0 0 4px 0 #3a4f970a !important;
}

.confirm-close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 24px;
  height: 24px;
  color: white;
}

.confirm-title {
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 600;
  color: white;
  text-align: center;
  width: 296px;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 0;
  line-height: 24px;
  margin: 0 auto;
}

.confirm-message {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: white;
  margin-top: 12px;
}

.confirm-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.btn-cancel {
  color: white;
  font-weight: 600;
  width: 124px;
}

.btn-confirm {
  color: white;
  font-weight: 600;
  min-width: 100px;
  border-radius: 12px;
}
</style>
